import { Children, cloneElement, createElement, FC, PropsWithChildren, ReactElement } from 'react';

import { PopoverContent, usePopoverContext, VStack } from '@bonusly/design-system';

import { useSelect } from '../../../hooks/use-select';
import { HighlightTabOptionContext, useHighlightTabDropdownContext } from './context';

type HighlightTabOptionsProps = PropsWithChildren;

export const HighlightTabOptions: FC<HighlightTabOptionsProps> = ({ children, ...rest }) => {
	const validChildren = Children.toArray(children);

	const { indexOffset } = useHighlightTabDropdownContext();
	const { isOpen } = usePopoverContext();

	const { getMenuProps, getOptionProps } = useSelect({
		items: validChildren,
		isOpen,
	});

	return (
		<PopoverContent borderColor="bg.subtle" boxShadow="xl" minW="160px" p={1} width="auto" {...rest}>
			<VStack {...getMenuProps()}>
				{Children.toArray(children).map((child, index) =>
					createElement(
						HighlightTabOptionContext.Provider,
						{
							key: (child as ReactElement).key || index,
							value: { index: index + indexOffset },
						},
						cloneElement(child as ReactElement, getOptionProps(index))
					)
				)}
			</VStack>
		</PopoverContent>
	);
};
